import styled from "styled-components"

export const SimpleBannerStyles = styled.section`
  height: 70vh;
  position: relative;
  padding: 30px var(--borderSpacing);

  .container {
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
  }

  .banner__image {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
  }

  .banner__content {
    position: relative;
    z-index: 2;
    background-color: rgba(255, 255, 255, 0.6);
    border-radius: 25px;
    border-style:solid;
    border-width:4px;  
    border-color: #ff6600;
    padding: 15px;


    min-height: 13vh;
    width: 100%;

    @media (min-width: 768px) {
      width: 30%;
    }

    h1 {
      margin-top: 0;
      margin-bottom: 10px;
      margin-left:30px;
      font-weight: 700;
      font-size: var(--bannerTitle);
      letter-spacing: -1px;
    }

    h2 {
      margin-top: 0;
      margin-bottom: 30px;
      font-weight: 300;
      font-size: var(--bannerSubTitle);
      letter-spacing: -0.5px;
    }
  }
`
